import api from "PFCore/api";
import { MetaWithPagination, SkillsFramework } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

export type SkillsFrameworksResponse = {
  entries: SkillsFramework[];
  meta: MetaWithPagination;
};

export const fetchSkillsFrameworks = (params: QueryParams = {}): Promise<SkillsFrameworksResponse> =>
  api({
    url: "admin/skills_framework/templates",
    params: { page: 1, perPage: 20, ...params }
  });
